import { Box, Button, Typography, useTheme } from '@mui/material';
import React from 'react';

const PaymentButton = ({ type, text, onPaymentButtonClick }) => {
  const theme = useTheme();

  const handleSubmit = () => {
    onPaymentButtonClick(type);
  };

  const commonStyles = {
    //width: 500,
    height: 280,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 2,
    border: '1px solid #ccc',
    borderRadius: 2,
  };

  const logoBoxStyles = {
    width: '100%',
    height: 55,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const logoImageStyles = {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  };

  const legalTextStyles = {
    fontSize: '0.8rem',
    textAlign: 'justify',
    minHeight: 85,
  };

  return (
    <Box maxWidth='lg' sx={commonStyles}>
      {type === 'BANK_TRANSFER' && (
        <>
          <Typography textAlign='center'>
            Banki átutalás díjbekérő alapján
          </Typography>

          <Box sx={logoBoxStyles}>
            <img
              src={process.env.PUBLIC_URL + '/img/bank-transfer.jpg'}
              alt='Bank transfer'
              style={logoImageStyles}
            />
          </Box>

          <Button variant='contained' color='success' onClick={handleSubmit}>
            {text}
          </Button>

          <Typography sx={legalTextStyles}>
            Az átutaláshoz a Billingo számlázási rendszerből kiállított
            díjbekérőt küldünk e-mail üzenetben
          </Typography>
        </>
      )}

      {type === 'BANK_CARD' && (
        <>
          <Typography textAlign='center'>
            Azonnali fizetés bankkártyával vagy Barion egyenleggel
          </Typography>

          <Box sx={logoBoxStyles}>
            <img
              src={
                process.env.PUBLIC_URL +
                '/img/barion-card-strip-intl__medium.png'
              }
              alt='Barion'
              style={logoImageStyles}
            />
          </Box>

          <Button variant='contained' color='success' onClick={handleSubmit}>
            {text}
          </Button>

          <Typography sx={legalTextStyles}>
            A szolgáltatást nyújtó <strong>Barion Payment Zrt.</strong> a{' '}
            <strong>Magyar Nemzeti Bank</strong> felügyelete alatt álló e-pénz
            kibocsátó, engedélyének száma: H-EN-I-1064/2013.
          </Typography>
        </>
      )}
    </Box>
  );
};

export default PaymentButton;
